import {qs, qsArray} from './utilities/index';
import Overlay from "./overlay";

let ProgressBar = function () {
  if (ProgressBar.prototype._singletonInstance) {
    return ProgressBar.prototype._singletonInstance;
  }
  ProgressBar.prototype._singletonInstance = this;

  this.initialize();
}

ProgressBar.prototype.initialize = function () {

  let self = this;

  let parent = document.getElementById('question-progress-bar');
  

  this.setProgress = function (currentQuestion, totalQuestions) {
    let wrap = document.querySelector('#question-progress-bar .progress-bar-wrap');
    let bars = document.querySelectorAll('#question-progress-bar .progress-bar-wrap .progress-bar');
    let previous = document.getElementById('previous');
    
    var barCount = bars.length;
    while (barCount < totalQuestions) {
      wrap.insertAdjacentHTML('beforeend', '<div class="progress-bar"></div>');
      barCount++;
    }
    while (barCount > totalQuestions) {
      wrap.removeChild(wrap.children[wrap.children.length - 1]);
      barCount--;
    }

    if (currentQuestion < 1) {
      previous.disabled = true;
    } else {
      previous.disabled = false;
    }

    let y;
    for (y = 0; y < totalQuestions; y++) {
      if (y < currentQuestion) {
        document.querySelectorAll('#question-progress-bar .progress-bar-wrap .progress-bar')[y].classList.add('complete');
      } else {
        document.querySelectorAll('#question-progress-bar .progress-bar-wrap .progress-bar')[y].classList.remove('complete');
      }
    }
  }

  this.show = function () {
    TweenLite.set([parent], { opacity: 0 });
    TweenLite.to([parent], 0.5, { opacity: 1 });
  }

  this.hide = function () {
    TweenLite.to([parent], 0.25, { opacity: 0 });
  }

}

export default ProgressBar;
